import React, { forwardRef } from "react";
import styles from "./slots.module.css";
import { DateTime } from "luxon";
import useIsMobile from '@/shared/lib/hooks/useIsMobile';

const ZONE = "Europe/Saratov";

function timeLabelHHmm(timeHHmmss) {
  return String(timeHHmmss ?? "").slice(0, 5);
}

const SlotTooltip = forwardRef(({ tooltip, onClose }, ref) => {
  const isMobile = useIsMobile();

  if (!tooltip) return null;

  const { x, y, occ, roomNameFallback } = tooltip;
  
  // Форматируем время для отображения
  const startTime = timeLabelHHmm(occ.startTime || occ.slotStartTime);
  const endTime = timeLabelHHmm(occ.endTime || occ.slotEndTime);

  // Форматируем дату
  const slotDate = occ.slotDate
    ? DateTime.fromISO(occ.slotDate, { zone: ZONE }).toFormat("dd.MM.yy")
    : "";

  // Для мобильных - показываем попап
  if (isMobile) {
    return (
      <div className={styles.mobileOverlay} onClick={onClose}>
        <div 
          className={styles.mobilePopup}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.mobileHeader}>
            <h3 className={styles.mobileTitle}>Занятый слот</h3>
            <button
              className={styles.mobileClose}
              onClick={onClose}
              aria-label="Закрыть"
            >
              ×
            </button>
          </div>

          <div className={styles.mobileBody}>
            <div className={styles.mobileRow}>
              <span className={styles.mobileLabel}>Зал</span>
              <span className={styles.mobileValue}>{roomNameFallback}</span>
            </div>

            <div className={styles.mobileRow}>
              <span className={styles.mobileLabel}>Дата</span>
              <span className={styles.mobileValue}>{slotDate}</span>
            </div>

            <div className={styles.mobileRow}>
              <span className={styles.mobileLabel}>Время</span>
              <span className={styles.mobileValue}>
                {startTime} - {endTime}
              </span>
            </div>

            {occ.status && (
              <div className={styles.mobileRow}>
                <span className={styles.mobileLabel}>Статус</span>
                <span className={styles.mobileValue}>
                  <span
                    className={`${styles.statusBadge} ${styles[`status-${occ.status.toLowerCase()}`]}`}
                  >
                    {occ.status}
                  </span>
                </span>
              </div>
            )}
          </div>

          <div className={styles.mobileFooter}>
            <button className={styles.mobileCloseBtn} onClick={onClose}>
              Закрыть
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Для десктопа - показываем тултип как раньше
  return (
    <div className={styles.tooltipOverlay}>
      <div
        ref={ref}
        className={styles.tooltipContent}
        style={{
          left: `${x}px`,
          top: `${y}px`,
          transform: "translateX(-50%)",
        }}
      >
        <div className={styles.tooltipHeader}>
          <h4 className={styles.tooltipTitle}>Занятый слот</h4>
          <button
            className={styles.tooltipClose}
            onClick={onClose}
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>

        <div className={styles.tooltipBody}>
          <div className={styles.tooltipRow}>
            <span className={styles.tooltipLabel}>Зал:</span>
            <span className={styles.tooltipValue}>{roomNameFallback}</span>
          </div>

          <div className={styles.tooltipRow}>
            <span className={styles.tooltipLabel}>Дата:</span>
            <span className={styles.tooltipValue}>{slotDate}</span>
          </div>

          <div className={styles.tooltipRow}>
            <span className={styles.tooltipLabel}>Время:</span>
            <span className={styles.tooltipValue}>
              {startTime} - {endTime}
            </span>
          </div>

          {occ.status && (
            <div className={styles.tooltipRow}>
              <span className={styles.tooltipLabel}>Статус:</span>
              <span className={styles.tooltipValue}>
                <span
                  className={`${styles.statusBadge} ${styles[`status-${occ.status.toLowerCase()}`]}`}
                >
                  {occ.status}
                </span>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

SlotTooltip.displayName = "SlotTooltip";

export default SlotTooltip;